import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import '../../App.css';
import BarraBotoes from '../../components/BarraBotoes/BarraBotoes';
import FormPadrao from '../../components/FormPadrao/FormPadrao';
import Pagina from '../../components/Pagina/Pagina';
import Tabela from '../../components/Tabela/Tabela';
import api from '../../services/api';
import './TabelasPreco.css';
import Alerta from '../../components/Alerta/Alerta';
import AlertaConfirmacao from '../../components/AlertaConfirmacao/AlertaConfirmacao';
import { useDisclosure } from '@chakra-ui/react';

function ListarTabelasPreco() {
  const navigate = useNavigate();
  const [tabelasPreco, setTabelasPreco] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchBar, setSearchBar] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: false });
  const [alertStatus, setAlertStatus] = useState('success');
  const {
    isOpen: isOpenExcluir,
    onOpen: onOpenExcluir,
    onClose: onCloseExcluir,
  } = useDisclosure({
    defaultIsOpen: false,
  });
  const [alertTitle, setAlertTitle] = useState('');
  const [message, setMessage] = useState('');
  const [selectedItem, setSelectedItem] = useState('');

  useEffect(() => {
    async function GetTabelasPreco() {
      let payload = {
        database: localStorage.getItem('database'),
        data: '{}',
      };
      let res = await api.post('/ListTabelas/Get', payload);
      if (res.status === 200) {
        let data = res.data.Tabelas;
        data.forEach(b => {
          b.Selecionado = false;
        });
        setTabelasPreco(data);
        setLoading(false);
      } else {
        alert('Erro ao buscar dados');
      }
    }
    GetTabelasPreco();
  }, []);

  function handleEdit(item) {
    navigate(`/TabelasPreco/Editar/${item.Id}`);
  }

  function handleClick() {
    navigate('/TabelasPreco/Editar');
  }

  const deleteItem = async idTabela => {
    let database = localStorage.getItem('database');

    let payload = {
      database: database,
      data: idTabela
    };
    let res = await api.post('/ListTabelas/Delete', payload);
    let data = res.data;
    onCloseExcluir();

    setTabelasPreco(prevTabelas => {
      return prevTabelas.filter(q => q.Id !== selectedItem);
    });

    if (data.Success) {
      setAlertStatus('success');
      setAlertTitle(data.MSG);
      onOpen();
    } else {
      setAlertStatus('error');
      setAlertTitle(data.MSG);
      onOpen();
    }
  };

  function handleDelete(item) {
    setSelectedItem(item.Id);
    setAlertTitle('Excluir');
    setMessage(`Deseja excluir a tabela ${item.Nome}?`);
    onOpenExcluir();
  }

  return (
    <>
      <Alerta
        isOpen={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        alertStatus={alertStatus}
        title={alertTitle}
      />
      <AlertaConfirmacao
        isOpen={isOpenExcluir}
        onClose={onCloseExcluir}
        description={message}
        title={alertTitle}
        onConfirm={() => deleteItem(selectedItem)}
      />
      <Pagina loading={loading}>
        <FormPadrao>
          <BarraBotoes
            botoes={[
              {
                children: 'Nova',
                onClick: handleClick,
                variant: 'turquesa',
              },
            ]}
            search={{
              placeholder: 'Procurar por Tabela de Preço',
              onChange: e => setSearchBar(e.target.value),
            }}
          />
          <Tabela
            titulo={'LISTAGEM DE TABELAS DE PREÇO'}
            setFunction={setTabelasPreco}
            data={tabelasPreco}
            columns={[
              {
                placeholder: 'NOME',
                name: 'Nome',
                type: 'text',
              },
              {
                placeholder: 'EMPRESA',
                name: 'Empresa',
                type: 'text',
              },
              {
                placeholder: 'GÊNERO',
                name: 'Genero',
                type: 'text',
              },
            ]}
            searchBar={searchBar}
            handleEdit={handleEdit}
            showDelete={true}
            handleDelete={handleDelete}
            useCheck={false}
          />
        </FormPadrao>
      </Pagina>
    </>
  );
}

export default ListarTabelasPreco;
